import { render, staticRenderFns } from "./OshaCitationModal.vue?vue&type=template&id=603d19c8"
import script from "./OshaCitationModal.vue?vue&type=script&lang=js"
export * from "./OshaCitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports